import { 
  SET_LEAD_SOURCE, 
  SET_SALES_DATA, 
  SET_USERS_DATA, 
  SET_SALES_STAGE_LEAD, 
  CLEAR_SALES_DATA, 
  LOGOUT, 
  SET_SALESL2M_DATA, 
  CLEAR_L2M_DATA, 
  PROJECT_NO,   
  SET_DESIGN_STAGE_LEAD,
  SET_MEETING_TRACKER,
  SET_STAGE_REVIEW,
  MONTHLY_CONVERSION_GOAL,
  LEADS_GENERATED_DASHBOARD,
  LEAD_SOURCE_TYPE_BOOKING_REPORT,
  LEADS_SOURCE_TRACKER,
  LEADS_LIFECYCLE_DASHBOARD,
  CHANNEL_PARTNER_DASHBOARD,
  IDSO_DASHBOARD,
  DSO_DASHBOARD,
  SOD_DASHBOARD,
  SOC_DASHBOARD,
  PPS_DASHBOARD,
  UES_DASHBOARD
} from "../actions/types";

const initialState = {
  leadSource: null,
  salesData: null,
  usersData: null,
  salesStageLead: null,
  salesL2MData: null,
  projectNumber: null,
  designSummary: null,
  meetingTracker: null,
  stageReview: null,
  monthlyConversionData: null,
  lgdData: null,
  lstbrData: null,
  lstData: null,
  lldData:null,
  cpdData: null,
  idsoData: null,
  dsoData: null,
  sodData: null,
  socData: null,
  ppsData: null,
  uesData: null,
};

const leadSourceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LEAD_SOURCE:
      return { ...state, leadSource: action.payload };

    case SET_SALES_DATA:
      return { ...state, salesData: action.payload };

    case PROJECT_NO:
      return { ...state, projectNumber: action.payload };

    case SET_USERS_DATA:
      return { ...state, usersData: action.payload };

    case SET_SALESL2M_DATA:
      return { ...state, salesL2MData: action.payload };

    case SET_SALES_STAGE_LEAD:
      return { ...state, salesStageLead: action.payload };

    case SET_DESIGN_STAGE_LEAD:
      return { ...state, designSummary: action.payload };

    case SET_MEETING_TRACKER:
      return { ...state, meetingTracker: action.payload };

    case SET_STAGE_REVIEW:
      return { ...state, stageReview: action.payload };

    case CLEAR_SALES_DATA:
      return { ...state, salesStageLead: null };

    case MONTHLY_CONVERSION_GOAL:  
      return { ...state, monthlyConversionData: action.payload };
    case LEADS_GENERATED_DASHBOARD:
      return { ...state, lgdData: action.payload };
    case LEAD_SOURCE_TYPE_BOOKING_REPORT:
      return { ...state, lstbrData: action.payload };
    case LEADS_SOURCE_TRACKER:
      return { ...state, lstData: action.payload };
    case LEADS_LIFECYCLE_DASHBOARD:
      return { ...state, lldData: action.payload };
    case CHANNEL_PARTNER_DASHBOARD:
      return { ...state, cpdData: action.payload };
    case IDSO_DASHBOARD:
      return { ...state, idsoData: action.payload };
    case DSO_DASHBOARD:
      return { ...state, dsoData: action.payload };
    case SOD_DASHBOARD:
      return { ...state, sodData: action.payload };
    case SOC_DASHBOARD:
      return { ...state, socData: action.payload };
    case PPS_DASHBOARD:
      return { ...state, ppsData: action.payload };
    case UES_DASHBOARD:
      return { ...state, uesData: action.payload };

    case CLEAR_L2M_DATA:
      return { ...state, salesL2MData: null };

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

export default leadSourceReducer;